/**
 * The signed-in staff member's active brokerages.
 *
 * One shared queryKey so every consumer — the sidebar switcher, the nav's
 * brokerage-type gating, and the merged list/dashboard fetches — rides ONE
 * cached request instead of each firing the endpoint independently.
 */

import { useQuery } from "@tanstack/react-query";
import {
  membershipService,
  type TenantMembership,
} from "@re-platform/api-client";

import { api } from "./api";

export function useMemberships() {
  return useQuery<TenantMembership[]>({
    queryKey: ["memberships"],
    queryFn: async () =>
      (await membershipService.listMemberships(api)).memberships,
    staleTime: 60_000,
    retry: false,
  });
}
